import SearchEngineAdapter from 'Services/Adapters/SearchEngineBeta/SearchEngineAdapter';
import SupportTicketStatus from 'Config/authenticated/SupportTicketStatus';
import { v4 as uuidv4 } from 'uuid';
export default class SupportTicketAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'ticket';
    }

    constructor(data = [], query = '') {
        super(data, query);
        this.key = SupportTicketAdapter._key;
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Support'),
            count: 0,
            items: [],
            filters: ['ticket'],
        };
    }

    formatItem(item) {
        return {
            id: this.checkFieldForQuery(item.index),
            subject: this.checkFieldForQuery(item.subject),
            type: item.object.sub_type,
            status: {
                id: item.step,
                label: SupportTicketStatus[item.step].label,
            },
            link: `/?_f=support_ticket&tid=${item.object.id}`,
            component: 'search-result-support',
            third: item.related.length ? this.checkFieldForQuery(item.related[0]) : '',
            uuid: uuidv4(),
        };
    }
}
